import Router from './Router';
import Route from './Route';

const appRouter = new Router();

export { appRouter as Router, Route };
